import { round } from '../utils/round';

/** (This should actually be ImpactCategory: legacy issue) */
export enum ImpactType {
  TREES = 'TREES',
  CARBON_OFFSETS = 'CARBON_OFFSETS',
  CARBON_REMOVAL = 'CARBON_REMOVAL',
  HABITAT_RESTORATION = 'HABITAT_RESTORATION',
}

export type CarbonUnit = 'grams' | 'kilograms' | 'tonnes';
export type AreaUnit = 'cm2' | 'm2';
export type ImpactUnit = CarbonUnit | AreaUnit;

export const GRAMS_PER_TONNE = 1_000_000;
export const GRAMS_PER_KILOGRAM = 1_000;
export const CM2_PER_M2 = 10_000;

export const impactTypeUnitConversions: Record<ImpactType, (quantity: number) => number> = {
  [ImpactType.TREES]: quantity => quantity,
  [ImpactType.CARBON_OFFSETS]: grams => round(grams / GRAMS_PER_TONNE, 4),
  [ImpactType.CARBON_REMOVAL]: grams => round(grams / GRAMS_PER_TONNE, 4),
  [ImpactType.HABITAT_RESTORATION]: cm2 => round(cm2 / CM2_PER_M2, 4),
};
